import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { CollapseIcon } from '../appearence/icons/collapse_icon';
import { ExitIcon } from '../appearence/icons/exit_icon';
import { LogoIcon } from '../appearence/icons/logo_icon';
import { SearchHandler } from './sharedComponents/SearchHandler';
import { BANNER_TAB, CONFIGURATION_TAB, INTEGRATION_TAB, NOTIFICATIONS_TAB, ORDERS_TAB, PRODUCTS_TAB, REQUESTS_TAB, SALES_TAB, STATISTIC_TAB, STOCK_TAB, USERS_TAB, PURCHASES_TAB, errorCallback, makeUrl} from "../constant";
import { LOGOUT_REQUEST, postFetchRequest } from '../store/requests';

const getTitleByLocation = (pathname) => {
    let result = '';
    if(pathname.includes(USERS_TAB) || pathname.includes(ORDERS_TAB) || pathname.includes(SALES_TAB)) {
        result = 'Продажи';
    }
    if(pathname.includes(PURCHASES_TAB)) {
        result = 'Закупки';
    }
    if(pathname.includes(STATISTIC_TAB)) {
        result = 'Статистика';
    }
    if(pathname.includes(STOCK_TAB)) {
        result = 'Склады';
    }
    if(pathname.includes(PRODUCTS_TAB)) {
        result = 'Продукты';
    }
    if(pathname.includes(INTEGRATION_TAB)) {
        result = 'Интеграции';
    }
    if(pathname.includes(NOTIFICATIONS_TAB)) {
        result = 'Уведомления';
    }
    if(pathname.includes(CONFIGURATION_TAB)) {
        result = 'Конфигурация';
    }
    if(pathname.includes(BANNER_TAB)) {
        result = 'Баннер';
    }
    if(pathname.includes(REQUESTS_TAB)) {
        result = 'Запросы';
    }
    return result;
};

const Header = ({ setIsCollapsed, isCollapsed, setIsAuthenticated }) => {
    const [scroll, setScroll] = useState(0);
    const [usdRate, setUsdRate] = useState(null);
    const [rateDate, setRateDate] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const title = getTitleByLocation(location.pathname);

    const CustomRouter = {
        navigate: (path) => navigate(path),
    };

    useEffect(() => {
        const handleScroll = () => {
            setScroll(window.scrollY || 0);
        };
        handleScroll();
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const fetchUsdRate = async () => {
        try {
            const response = await fetch(makeUrl(['/api/v1/integration/currency/rate/']), { cache: 'no-store' });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            if (data && typeof data.rate === 'number' && data.rateDate) {
                setUsdRate(data.rate);
                setRateDate(data.rateDate);
            }
        } catch (error) {
            console.error('Ошибка при получении курса ЦБ:', error);
            setUsdRate(95.0);
            setRateDate(new Date().toLocaleDateString('ru-RU', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                timeZone: 'Europe/Moscow',
            }));
        }
    };

    useEffect(() => {
        fetchUsdRate();
        const interval = setInterval(fetchUsdRate, 3600000);
        return () => clearInterval(interval);
    }, []);

    const succesCallback = (response) => {
        if(response && response.status === 200) {
            setIsAuthenticated(false);
            navigate("/login");
        }
    };

    const handleLogout = () => {
        postFetchRequest(makeUrl([LOGOUT_REQUEST]), '', succesCallback, errorCallback);
    };
    return (
        <header className="header admin">
            <div className="menu-common">
                <LogoIcon />
                <div className="menu-middle__cbrf">
                    {usdRate ? (
                        <>
                            <span>Курс $ ЦБ на</span> {rateDate} <span>|</span> <p>{usdRate.toFixed(4)} Р</p>
                        </>
                    ) : 'Загрузка курса...'}
                </div>
                <div className="menu-common__exit navigation-link" onClick={handleLogout}>
                    <ExitIcon />
                    <span className="menu-common__exit-text">Выход</span>
                </div>
            </div>
            <nav className={`menu-bottom container ${scroll > 200 ? 'menu-bottom_sticky' : ''}`}>
                <CollapseIcon
                    nameOfClass={`info__collapse-icon ${isCollapsed ? 'info__collapse-icon_collapsed' : 'info__collapse-icon_full-width'} navigation-link`}
                    setIsCollapsed={setIsCollapsed}
                />
                <h3
                    className={`info__page-title ${isCollapsed ? 'info__page-title_collapsed' : ''} navigation-link`}
                    onClick={() => setIsCollapsed((prev) => !Boolean(prev))}
                >
                    {title}
                </h3>
                <SearchHandler CustomRouter={CustomRouter} isMobile={false} />
            </nav>
        </header>
    );
};

export default Header;